import core from "@/helpers/client";
const serviceService = {
  async headServiceAsync(referenceId, logtype, params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Documents/${referenceId}/logs/${logtype}?no-cache=1`,
      params
    );
    return result;
  },
  async getDocumentLogsAsync(referenceId, logtype, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Documents/${referenceId}/logs/${logtype}?no-cache=1`,
      params
    );
    return result;
  },
  async getDocumentLogsCompareAsync(referenceId, logtype, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Documents/${referenceId}/logs/${logtype}/compare?no-cache=1`,
      params
    );
    return result;
  },
  async getServiceAsync(referenceId, id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Documents/${referenceId}/logs/${logtype}/${id}?no-cache=1`
    );
    return result;
  },
  async createServiceAsync(referenceId, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Documents/${referenceId}/logs/${logtype}`,
      model
    );
    return result;
  },
  async updateServiceAsync(referenceId, id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Documents/${referenceId}/logs/${logtype}/${id}`,
      model
    );
    return result;
  },
  async deleteBrandMasterByIdAsync(referenceId, id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Documents/${referenceId}/logs/${logtype}/${id}`
    );
    return result;
  },
};
export default serviceService;
